import React from 'react';

const Indeterminado = () => {
    return (
        <div className='row m-p-0' style={{position:'fixed',top:'0',left:'0',width:'100%',zIndex:'1000'}}> 
            <div className="progress">
                <div className="indeterminate"></div>
            </div>
        </div>
    );
};

export default Indeterminado;